export default __webpack_public_path__ + "static/media/LineosoftArticleListing-min.d8a09848.PNG";